module.exports = __webpack_public_path__ + "img/au_logo.a6c82a78.png";